/*** IMPORTS FROM imports-loader ***/
var define = false;

// Frameworks
import './frameworks/bootstrap.js'; import './frameworks/hamburgers.js'; import './frameworks/slick-lightbox.js'; import './frameworks/slick.js'; import './frameworks/waypoints.js';

// Includes
import './includes/animate.js'; import './includes/slider.js';


jQuery(document).ready(function($) {

    $('#borlabs-cookie-google-forms').click(function() {
        location.reload();
    });

});

